// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51e77d93","723":"324fe547"}[chunkId] + ".chunk.js";
};